import React from 'react'
import TagBrandForm from './TagBrandForm'

const TagBrandNewPage = () => {
  return <TagBrandForm />
}

export default TagBrandNewPage